import * as React from "react";
import PropTypes from "prop-types";
const SvgLogosGoogleSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M21 12.207c0-.606-.054-1.18-.146-1.74h-8.659v3.456h4.958c-.222 1.134-.873 2.092-1.839 2.744v2.298h2.958C20.004 17.364 21 15.004 21 12.207z"
        fill="#4285f4"
      />
      <path
        d="M12.195 21.195c2.483 0 4.56-.827 6.077-2.23l-2.958-2.298c-.827.551-1.877.889-3.119.889-2.398 0-4.429-1.617-5.157-3.801h-3.05v2.368c1.51 3.003 4.614 5.072 8.207 5.072z"
        fill="#34a853"
      />
      <path
        d="M7.038 13.755c-.191-.552-.29-1.142-.29-1.755s.106-1.203.29-1.755V7.877h-3.05a9.089 9.089 0 000 8.246z"
        fill="#fbbc05"
      />
      <path
        d="M12.195 6.444c1.357 0 2.567.468 3.525 1.38l2.621-2.62c-1.586-1.488-3.663-2.4-6.146-2.4-3.593 0-6.697 2.07-8.207 5.073l3.05 2.368c.728-2.184 2.759-3.8 5.157-3.8z"
        fill="#ea4335"
      />
    </svg>
  )
);
SvgLogosGoogleSmall.defaultProps = {
  color: "currentColor",
  size: 24,
  title: undefined,
  titleId: undefined,
};
SvgLogosGoogleSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgLogosGoogleSmall;
